import { render, staticRenderFns } from "./CompanyCardContactAddress.vue?vue&type=template&id=0de00947&scoped=true&"
import script from "./CompanyCardContactAddress.vue?vue&type=script&lang=ts&"
export * from "./CompanyCardContactAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de00947",
  null
  
)

export default component.exports